import React, { Component } from 'react';
import { IReducerState } from '../../../states/renditionStates';
import { connect } from 'react-redux';
import { RenditionLoadable } from '../../../utils/general/LoadableRelated';
import _ from 'lodash';
import $ from 'jquery';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { RSCH_HTML_TRACKING_CONFIG } from '../../../readership/trackingConfig';
import { Carousel } from 'react-bootstrap';
import IFramePage from './../../../containers/innerPagePart/iframePage';
import commonStore from '../../../store/commonStore.js';
import * as commonStateAction from '../../../actions/commonStateAction';
import * as deviceInfoService from '../../../utils/general/deviceInfoService';
import { enterKeyPressed, onKeyDown } from '../../../utils/general/enterKey';
import { wrapperUrlwithEPFToken, isThirdPartyTokenAuthorization } from '../../../utils/general/general';

const ModalPopup = RenditionLoadable({
    loader: () => import('../../../modalrelated/modalPopup'),
}, "modalPopup", Date.now());

const NormalScreenPopup = RenditionLoadable({
    loader: () => import('../../../modalrelated/normalScreenPopup'),
}, "normalScreenPopup", Date.now());

interface IStyleAndFactorsProps {
    source?: any;
    docHeaderSectionJson: any;
    initialData: any;
    styleFactorsData: any;
    multiCompanyMetaData: any;
    menuPaneStatus: string;
    propsCallback: () => void;
    showOldBranding?: boolean;
}

interface IStyleAndFactorsStatus {
    modalStatus: boolean;
    modalTitle: string;
    slideIndex: number;
    modalWidth: number;
    urls: Array<string>;
}

export class StyleAndFactors extends Component<IStyleAndFactorsProps, IStyleAndFactorsStatus> {
    public galleryDropdown: any;
    public debounceFun = _.debounce(_.bind(this.handleResize, this), 200);

    constructor(props: IStyleAndFactorsProps) {
        super(props);
        this.state = {
            modalStatus: false,
            modalTitle: '',
            slideIndex: 0,
            modalWidth: 1000,
            urls: [],
        };
    }

    public handleResize() {
        setTimeout(() => {
            const windowHeight: number = $(window).height() || 0;
            const reduceNum = deviceInfoService.isDeviceScreenType() ? 150 : 100;
            $('.quant-carousel.carousel').height(windowHeight - reduceNum);
        }, 200);
    }

    public openModal(e: any) {
        if (deviceInfoService.isDeviceScreenType()) {
            commonStore.dispatch(commonStateAction.menuPaneStatus(''));
            $('#rightPartContain').hide();
        }
        if (e.target.id === "modalClose") { // Improtant!!! if you want close modal in more case only change this if
            this.setState({
                modalStatus: false,
            });
            $('.triggered_popup_flag').focus().removeClass('triggered_popup_flag');
            window.removeEventListener('resize', this.debounceFun);
        } else if (this.state.modalStatus === false) { // Improtant!!! don't change this if in any case
            this.handleResize();
            this.setState({
                modalStatus: true,
            });
            e.target.className += " triggered_popup_flag";
            window.addEventListener('resize', this.debounceFun);
        }
    }

    public openStyleFactorCharts = () => {
        RSCH_HTML_TRACKING_CONFIG.trackStylesAndFactorClick();
        const { docHeaderSectionJson, multiCompanyMetaData } = this.props;
        const companyNameAndTicker = (_.isNull(multiCompanyMetaData) || _.isUndefined(multiCompanyMetaData))  ?
                docHeaderSectionJson.metadata.companyNameAndTicker :
                multiCompanyMetaData.companyNameAndTicker;
        const _modalTitle = docHeaderSectionJson.i18n.styleAndFactors + ': ' + companyNameAndTicker;
        this.setState({
            modalTitle: _modalTitle
        });
    }

    public clickLeftNavItem = (e: any, page: number) => {
        const targetText = $(e.target).parents('div.dropdown-menu').find('a').eq(page).text();
        this.galleryDropdown?.text(targetText);
        $('ol.quant-carousel.carousel-indicators').find('li').eq(page || 0).click();
        setTimeout(() => {
            const clickedTab = $('#quant-left ul').find('li').eq(this.state.slideIndex || 0);
            clickedTab.addClass('selected');
            clickedTab.siblings().removeClass('selected');
            clickedTab.siblings().attr('aria-selected', 'false');
            clickedTab.attr('aria-selected', 'true');
            clickedTab.attr('tabindex', '0');
            clickedTab.focus();
        }, 200);
    }

    public collapseLeftPane($event: any) {
        $event.persist();
        if ($($event.target).hasClass('quant_collapsed')) {
            $('#quant-left').animate({ minWidth: 271, width: 271, opacity: 1 }, 300);
            $('#quant_slider').animate({ left: 271 }, 300);
            setTimeout(() => {
                $('#quant_slider, #quant-left').animate({ speed: 'slow' });
                $($event.target).removeClass('quant_collapsed');
            }, 200);
        } else {
            $('#quant-left').animate({ minWidth: 0, width: 0, opacity: 0 }, 300);
            $('#quant_slider').animate({ left: 0 }, 300);
            setTimeout(() => {
                $('#quant_slider, #quant-left').animate({ speed: 'slow' });
                $($event.target).addClass('quant_collapsed');
            }, 200);
        }
    }

    public getStyleFactorsDom(_source: any) {
        const quantCharts = JSON.parse(JSON.stringify(_source));
        const quantUrl = [];
        const leftMenuTplContent = [];
        let rightPaneTplContent = null;
        const _items = [];
        const temp: any = [];
        // If the isRestricted == 'Y' or isPeerRestricted == 'Y' ,
        // the first chart should not be shown otherwise all the 6 charts should be shown
        if (quantCharts.isRestricted == 'Y' || quantCharts.isPeerRestricted == 'Y') {
            quantCharts.charts.shift();
        }
        for (let i = 0; i < quantCharts.charts.length; i++) {
            quantUrl[i] = quantCharts.charts[i].akamaiLink;
            leftMenuTplContent.push(<li key={i} role="tab" id={'tab' + i} aria-selected={i === 0 ? 'true' : 'false'}
                onClick={(e: any) => this.clickLeftNavItem(e, i)} className={"quant-title" + i + (i === 0 ? ' selected' : '')}
                aria-label={quantCharts.charts[i].title} data-sequence={i}
                onKeyPress={(e) => enterKeyPressed(e, this.clickLeftNavItem.bind(this, e, i))}
                onKeyDown={(e) => onKeyDown(e,'quant-left-menu-id')}
                tabIndex={0} title={quantCharts.charts[i].title}>{quantCharts.charts[i].title}</li>);
            rightPaneTplContent =
                (<Carousel.Item key={i}>
                    <div>
                        <IFramePage iframePageUrl={this.state.urls[i] || quantUrl[i]} currentPage={'StyleAndFactors'} iframeId={`quant-${i}`} iframeStyle={{minWidth: '600px'}} iframeHolderStyle={{minWidth: '600px'}} />
                    </div>
                </Carousel.Item>);

            // dropdown part
            const dropdownText = <span>{quantCharts.charts[i].title}</span>;
            _items.push(
                <Dropdown.Item role="option" key={i} onClick={(e: any) => this.clickLeftNavItem(e, i)} aria-label={dropdownText} className='galleryDropDownItem'>
                    {dropdownText}
                </Dropdown.Item>);
            temp.push(rightPaneTplContent);
        }
        const leftMenuTpl =
            <div id="quant-left" role="Navigation" aria-label="Navigation Region" className="carousel-left-nav">
                <ul id="quant-left-menu-id" role="tabList">{leftMenuTplContent}</ul>
            </div>;

        const slider = <div id="quant_slider" aria-label="slider" tabIndex={0}
                            onClick={(e) => this.collapseLeftPane(e)}
                            onKeyPress={(e) => enterKeyPressed(e, this.collapseLeftPane.bind(this, e))}></div>;
        const quantDropDown =
            <div id="quant-dropdown-sort">
                <DropdownButton tabIndex={0} role="listbox" aria-label={'quant slider dropdown'} id='galleryDropdown' className="cv_mb_dropdown rendition_dropdown company-dropdown" title={'quant slider dropdown'}>
                    {_items}
                </DropdownButton>
            </div>;

        const handleSelect = (selectedIndex: any, e: any) => {
            this.setState({
                slideIndex: selectedIndex
            });
            this.clickLeftNavItem(e, selectedIndex);
        };

        const template =
            <div id="styleFactorCharts">
                {leftMenuTpl}
                {slider}
                <div className="quant-carousel-container">
                    {quantDropDown}
                    <Carousel
                        style={{ overflow: 'auto', height: '100%' }}
                        interval={0}
                        bsPrefix={'quant-carousel carousel'}
                        indicators={true}
                        onSelect={handleSelect}
                        tabIndex={0}
                    >
                        {temp}
                    </Carousel>
                </div>
            </div>;
        return template;
    }
    public getCurrentStyleFactorsSource() {
        const { styleFactorsData, multiCompanyMetaData, initialData } = this.props;
        let _source: any = null;
        if (!_.isEmpty(styleFactorsData)) {
            if (window.HTML_RENDITION.isMCN) {
                const multiCompanyCode = multiCompanyMetaData.companyCode;
                _source = styleFactorsData.find((item: any) => item.companyCode == multiCompanyCode);
            } else if (initialData.productType == 'company' || initialData.isFAVE == true) {
                _source = styleFactorsData[0];
            }
            return _source;
        }
    }
    public getWrapperEpfTokenUrls() {
        const quantCharts = this.getCurrentStyleFactorsSource();
        const isRestricted = quantCharts.isRestricted == 'Y' || quantCharts.isPeerRestricted == 'Y';
        return Promise.all((quantCharts?.charts || []).slice(isRestricted ? 1 : 0).map((item: any) =>  wrapperUrlwithEPFToken(item.akamaiLink))).then((urls) => {
          this.setState({urls});
        });
    }
    public shouldComponentUpdate(nextProps: IStyleAndFactorsProps, nextState:IStyleAndFactorsStatus) {
      if (nextState.modalStatus !== this.state.modalStatus && !this.state.modalStatus && isThirdPartyTokenAuthorization()) {
        this.getWrapperEpfTokenUrls();
      }
      return true;
    }

    public render() {
        const { docHeaderSectionJson, styleFactorsData } = this.props;
        const _modalStatus = this.state.modalStatus;
        let _modalSource = null;
        if (_modalStatus && !_.isEmpty(styleFactorsData)) {
            _modalSource = this.getStyleFactorsDom(this.getCurrentStyleFactorsSource());
            setTimeout(() => {
                this.galleryDropdown = $('#galleryDropdown');
                const targetText = $("#quant-left").find('li').eq(0).text();
                this.galleryDropdown.text(targetText);
            }, 500);
        }
        setTimeout(() => {
            this.props.propsCallback();
        }, 100);

        return (
            <div className="styleAndFactorsWrapper" onClick={(e) => this.openModal(e)} onKeyPress={(e) => enterKeyPressed(e, this.openModal.bind(this, e))}>
                {_modalStatus && _modalSource && this.state.modalTitle &&
                    <ModalPopup classList={"modal-quant"}>
                        <NormalScreenPopup titleSource={this.state.modalTitle}
                                           bodySource={_modalSource}
                                           modalWindowStyle={{width: '1000px',   // set the initial modal width equals 1000px for quant
                                                              background: 'transparent',
                                                              height: '700px'}}
                                           modalBodyStyle={{ overflow: 'initial'}}
                                           modalClass="style-factors-modal"
                                           isIframeContent
                        />
                    </ModalPopup>}
                <div className="styleAndFactors financials" onClick={this.openStyleFactorCharts} onKeyPress={(e) => enterKeyPressed(e, this.openStyleFactorCharts.bind(this))}>
                    {
                        this.props.showOldBranding ? <span className="icon-style-factor icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.styleAndFactors} /> : <span className="icon-svg-parent">
                        <span
                                className="icon-svg icon-styles-score-svg"
                                role="img"
                                aria-label={docHeaderSectionJson.i18n.styleAndFactors}
                            />
                        </span>
                    }
                    
                    <a tabIndex={0} role="link" aria-label={docHeaderSectionJson.i18n.styleAndFactors} id="request-style-factor"
                       className="x-rsch-hyperlink">{docHeaderSectionJson.i18n.styleAndFactors}</a>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
        styleFactorsData: state.asyncStateReducer.styleFactorsData,
        multiCompanyMetaData: state.commonStateReducer.multiCompanyMetaData,
        menuPaneStatus: state.commonStateReducer.menuPaneStatus,
    };
};

export default connect(mapStateToProps)(StyleAndFactors);
